export const paths = {
  rockyBonuses: '/rocky-bonuses',
  myMetrics: '/my-metrics',
  contractors: '/contractors',
  reports: '/reports',
  clientInvoice: '/client-invoice',
  approvals: '/approvals',
  submissions: '/submissions',
  kpiDefinitions: '/kpi-definitions',
  accounts: '/accounts',
  portfolio: '/portfolio',
  revenueStatus: '/revenue-status',
  sowAdmin: '/sow-admin',
  recentSowChanges: 'recent-sow-changes',
  termsOfUse: '/terms-of-use',
  admin: '/admin',
  projectStatus: 'project-status',
  ratesAndMargins: 'rates-and-margins',
  sowManagement: 'sow-management',
  timeAndPeople: 'time-and-people',
  invoices: 'invoices',
  risks: 'risks-and-alerts',
  alert: 'alert',
  forecast: 'forecast',
};
